// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "plan-manager .plan-list{height:80vh;overflow-y:auto}", "",{"version":3,"sources":["webpack://./src/app/modules/practiceplans/planmanager/planmanager.scss"],"names":[],"mappings":"AACE,wBACE,WAAA,CACA,eAAA","sourcesContent":["plan-manager {\n  .plan-list {\n    height: 80vh;\n    overflow-y: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
